(function () {
  const SECTION_SELECTOR = '[data-canicule-reviews]';
  const PRODUCT_HANDLES = [
    'ventilateur-brumisateur-portable',
    'mini-ventilateur-de-poche',
    'mini-ventilateur-bureau-usb-360'
  ];
  const USAGE_LABELS = {
    bureau: 'Bureau',
    deplacements: 'Déplacements',
    sport: 'Sport',
    chevet: 'Chevet',
    quotidien: 'Quotidien'
  };
  const PRODUCT_LABELS = {
    'ventilateur-brumisateur-portable': 'Brumisateur portable',
    'mini-ventilateur-de-poche': 'Ventilateur de poche',
    'mini-ventilateur-bureau-usb-360': 'Ventilateur bureau USB'
  };
  const SIZE_PATTERN = ['large', 'medium', 'small', 'medium', 'small', 'large', 'medium', 'small'];
  const HERO_ROTATION_MS = 6500;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function collectReviews(data, handle) {
    if (handle) {
      return (data[handle] || []).map(function (review) {
        return Object.assign({}, review, { productHandle: handle });
      });
    }
    return PRODUCT_HANDLES.reduce(function (acc, key) {
      const list = data[key];
      if (!Array.isArray(list)) return acc;
      return acc.concat(list.map(function (review) {
        return Object.assign({}, review, { productHandle: key });
      }));
    }, []);
  }

  function mergeIntelligence(data, handle) {
    if (handle && data.intelligence && data.intelligence[handle]) {
      return data.intelligence[handle];
    }
    if (!data.intelligence) return null;
    const appreciate = [];
    const caveats = [];
    PRODUCT_HANDLES.forEach(function (key) {
      const intel = data.intelligence[key];
      if (!intel) return;
      (intel.appreciate || []).forEach(function (item) {
        if (!appreciate.includes(item)) appreciate.push(item);
      });
      (intel.caveats || []).forEach(function (item) {
        if (!caveats.includes(item)) caveats.push(item);
      });
    });
    if (!appreciate.length && !caveats.length) return null;
    return { appreciate: appreciate, caveats: caveats };
  }

  function usageBadge(review) {
    if (!review.usage || !USAGE_LABELS[review.usage]) return '';
    return '<span class="canicule-reviews__usage-tag" aria-label="Usage : ' +
      escapeHtml(USAGE_LABELS[review.usage]) + '">✓ ' +
      escapeHtml(USAGE_LABELS[review.usage]) + '</span>';
  }

  function productLink(review) {
    if (!review.productHandle) return '';
    const label = PRODUCT_LABELS[review.productHandle] || review.productHandle;
    return '<a class="canicule-reviews__product-link" href="/products/' +
      escapeHtml(review.productHandle) + '">' + escapeHtml(label) + '</a>';
  }

  function attributionHtml(review) {
    if (!review.attribution) return '';
    if (review.sourceUrl) {
      return '<p class="canicule-reviews__attribution-line"><a href="' +
        escapeHtml(review.sourceUrl) + '" target="_blank" rel="noopener noreferrer">' +
        escapeHtml(review.attribution) + '</a></p>';
    }
    return '<p class="canicule-reviews__attribution-line">' + escapeHtml(review.attribution) + '</p>';
  }

  function renderSummary(root, reviews) {
    const summary = root.querySelector('[data-canicule-reviews-summary]');
    if (!summary || !reviews.length) return;
    summary.innerHTML =
      '<p class="canicule-reviews__summary-text">' +
      '<strong>' + reviews.length + '</strong> retours documentés' +
      ' · <span class="canicule-reviews__summary-note">marketplaces tierces, hors Canicule</span></p>';
    summary.hidden = false;
  }

  function renderIntelligence(root, data, handle) {
    if (root.dataset.showIntelligence !== 'true') return;
    const intelRoot = root.querySelector('[data-canicule-reviews-intelligence]');
    const intel = mergeIntelligence(data, handle);
    if (!intelRoot || !intel) return;

    function fillList(selector, items, wrapSelector) {
      const list = root.querySelector(selector);
      const wrap = list ? list.closest(wrapSelector) : null;
      if (!list || !items || !items.length) return;
      list.innerHTML = items.map(function (item) {
        return '<li>' + escapeHtml(item) + '</li>';
      }).join('');
      if (wrap) wrap.hidden = false;
    }

    fillList('[data-canicule-reviews-appreciate-list]', intel.appreciate, '[data-canicule-reviews-appreciate]');
    fillList('[data-canicule-reviews-caveats-list]', intel.caveats, '[data-canicule-reviews-caveats]');
    intelRoot.hidden = !(intel.appreciate && intel.appreciate.length);
  }

  function initFilterSpotlight(filters) {
    var SPOTLIGHT_MS = 5000;
    var MOBILE_MAX = 749;

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX;
    }

    var chips = Array.prototype.slice.call(filters.querySelectorAll('.canicule-reviews__filter'));
    if (chips.length < 2 || prefersReducedMotion()) return;

    var index = 0;
    var timer = null;
    var userEngaged = false;

    function inactiveChips() {
      return chips.filter(function (btn) {
        return !btn.classList.contains('is-active');
      });
    }

    function clearSpotlight() {
      chips.forEach(function (btn) {
        btn.classList.remove('is-spotlight');
      });
    }

    function advance() {
      if (document.hidden || userEngaged || isMobile()) {
        clearSpotlight();
        return;
      }
      var pool = inactiveChips();
      if (!pool.length) {
        clearSpotlight();
        return;
      }
      clearSpotlight();
      pool[index % pool.length].classList.add('is-spotlight');
      index += 1;
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      clearSpotlight();
    }

    function start() {
      if (timer || prefersReducedMotion() || isMobile()) return;
      advance();
      timer = setInterval(advance, SPOTLIGHT_MS);
    }

    function engage() {
      userEngaged = true;
      stop();
    }

    function disengage() {
      userEngaged = false;
      if (!document.hidden && !isMobile()) start();
    }

    filters.addEventListener('mouseenter', engage);
    filters.addEventListener('mouseleave', disengage);
    filters.addEventListener('focusin', engage);
    filters.addEventListener('focusout', function (event) {
      if (filters.contains(event.relatedTarget)) return;
      disengage();
    });
    filters.addEventListener('click', engage);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else if (!userEngaged && !isMobile()) start();
    });

    var widthQuery = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)');
    function onWidthChange() {
      if (isMobile()) stop();
      else if (!userEngaged && !document.hidden) start();
    }
    if (typeof widthQuery.addEventListener === 'function') {
      widthQuery.addEventListener('change', onWidthChange);
    } else if (typeof widthQuery.addListener === 'function') {
      widthQuery.addListener(onWidthChange);
    }

    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    function onMotionChange() {
      if (motionQuery.matches) stop();
      else if (!userEngaged && !document.hidden && !isMobile()) start();
    }
    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', onMotionChange);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(onMotionChange);
    }

    start();
  }

  function renderFilters(root, reviews, onFilter) {
    const filters = root.querySelector('[data-canicule-reviews-filters]');
    if (!filters) return;

    const usages = reviews.reduce(function (acc, r) {
      if (r.usage && !acc.includes(r.usage)) acc.push(r.usage);
      return acc;
    }, []);

    if (usages.length < 2) return;

    var BURST_MAP = { metro: 'breeze', bureau: 'stream', brume: 'mist', compact: 'pulse', all: 'breeze' };

    filters.innerHTML =
      '<button type="button" class="canicule-reviews__filter canicule-chip is-active" data-filter="all" data-canicule-airburst data-airburst-type="breeze" data-airburst-intensity="medium">Tous</button>' +
      usages.map(function (u) {
        var burst = BURST_MAP[u] || 'breeze';
        return '<button type="button" class="canicule-reviews__filter canicule-chip" data-filter="' +
          escapeHtml(u) + '" data-canicule-airburst data-airburst-type="' + burst +
          '" data-airburst-intensity="medium">' + escapeHtml(USAGE_LABELS[u] || u) + '</button>';
      }).join('');

    filters.hidden = false;
    filters.addEventListener('click', function (event) {
      const btn = event.target.closest('[data-filter]');
      if (!btn) return;
      filters.querySelectorAll('.canicule-reviews__filter').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      onFilter(btn.dataset.filter);
    });

    initFilterSpotlight(filters);
  }

  function renderHeroStage(root, reviews) {
    const hero = root.querySelector('[data-canicule-reviews-hero]');
    const carousel = root.querySelector('[data-canicule-reviews-hero-carousel]');
    const stage = root.querySelector('[data-canicule-reviews-hero-stage]');
    const dots = root.querySelector('[data-canicule-reviews-hero-dots]');
    const prevBtn = root.querySelector('[data-canicule-reviews-hero-prev]');
    const nextBtn = root.querySelector('[data-canicule-reviews-hero-next]');
    const toggleBtn = root.querySelector('[data-canicule-reviews-hero-toggle]');
    if (!hero || !stage || !reviews.length) return null;

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let featured = [];
    let index = 0;
    let timer = null;
    let hovering = false;
    let focusInside = false;
    let manualPaused = false;

    function reducedMotion() {
      return motionQuery.matches;
    }

    function canAutoplay() {
      return !reducedMotion() && featured.length > 1 && !manualPaused;
    }

    function buildQuoteHtml(review, i) {
      return '<blockquote class="canicule-reviews__hero-quote' +
        (i === 0 ? ' is-active' : '') + '" data-hero-index="' + i + '">' +
        '<p class="canicule-reviews__hero-text">« ' + escapeHtml(review.text) + ' »</p>' +
        '<footer class="canicule-reviews__hero-meta">' +
        usageBadge(review) +
        attributionHtml(review) +
        productLink(review) +
        '</footer></blockquote>';
    }

    function buildDotsHtml(count) {
      if (!dots || count < 2) return;
      dots.innerHTML = featured.map(function (_, i) {
        return '<button type="button" class="canicule-reviews__hero-dot' +
          (i === 0 ? ' is-active' : '') + '" data-hero-dot="' + i +
          '" role="tab" aria-label="Avis ' + (i + 1) + ' sur ' + count +
          '" aria-selected="' + (i === 0 ? 'true' : 'false') + '"></button>';
      }).join('');
      dots.hidden = false;
    }

    function setNavVisible(visible) {
      if (prevBtn) prevBtn.hidden = !visible;
      if (nextBtn) nextBtn.hidden = !visible;
    }

    function showSlide(next) {
      if (!featured.length) return;
      const count = featured.length;
      index = ((next % count) + count) % count;
      const quotes = stage.querySelectorAll('.canicule-reviews__hero-quote');
      const dotEls = dots ? dots.querySelectorAll('.canicule-reviews__hero-dot') : [];
      quotes.forEach(function (q, i) {
        q.classList.toggle('is-active', i === index);
      });
      dotEls.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function updateToggleUi(playing) {
      if (!toggleBtn) return;
      toggleBtn.textContent = playing ? '❚❚' : '▶';
      toggleBtn.setAttribute(
        'aria-label',
        playing
          ? 'Mettre en pause le défilement automatique des avis'
          : 'Reprendre le défilement automatique des avis'
      );
      toggleBtn.setAttribute('aria-pressed', playing ? 'false' : 'true');
    }

    // Silence screen-reader announcements while auto-advancing; announce on manual/paused nav.
    function setLive(playing) {
      hero.setAttribute('aria-live', playing ? 'off' : 'polite');
    }

    function clearRotation() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function beginTimer() {
      clearRotation();
      timer = setInterval(function () {
        if (document.hidden) return;
        showSlide(index + 1);
      }, HERO_ROTATION_MS);
      updateToggleUi(true);
      setLive(true);
    }

    function startRotation() {
      clearRotation();
      if (!canAutoplay() || hovering || focusInside || document.hidden) {
        updateToggleUi(false);
        setLive(false);
        return;
      }
      beginTimer();
    }

    function goTo(next) {
      showSlide(next);
      startRotation();
    }

    function paint(filtered) {
      featured = filtered.slice().sort(function (a, b) {
        return (b.text || '').length - (a.text || '').length;
      }).slice(0, 5);

      if (!featured.length) {
        clearRotation();
        hero.hidden = true;
        return;
      }

      stage.innerHTML = featured.map(buildQuoteHtml).join('');
      index = 0;

      const multi = featured.length > 1;
      if (multi) {
        buildDotsHtml(featured.length);
        setNavVisible(true);
      } else {
        if (dots) dots.hidden = true;
        setNavVisible(false);
      }
      if (toggleBtn) toggleBtn.hidden = !(multi && !reducedMotion());

      hero.hidden = false;
      startRotation();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    if (dots) {
      dots.addEventListener('click', function (event) {
        const btn = event.target.closest('[data-hero-dot]');
        if (!btn) return;
        goTo(parseInt(btn.dataset.heroDot, 10));
      });
    }

    hero.addEventListener('keydown', function (event) {
      if (featured.length < 2) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        manualPaused = !manualPaused;
        if (manualPaused) {
          clearRotation();
          updateToggleUi(false);
          setLive(false);
        } else if (canAutoplay() && !document.hidden) {
          // Explicit resume: honour user intent even though the control is focused.
          beginTimer();
        }
      });
    }

    // Pause only when the reader hovers/focuses the quote area, not the whole card.
    if (carousel) {
      carousel.addEventListener('mouseenter', function () {
        hovering = true;
        clearRotation();
        updateToggleUi(false);
        setLive(false);
      });
      carousel.addEventListener('mouseleave', function () {
        hovering = false;
        startRotation();
      });
      carousel.addEventListener('focusin', function () {
        focusInside = true;
        clearRotation();
        updateToggleUi(false);
        setLive(false);
      });
      carousel.addEventListener('focusout', function (event) {
        if (carousel.contains(event.relatedTarget)) return;
        focusInside = false;
        startRotation();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearRotation();
        updateToggleUi(false);
      } else {
        startRotation();
      }
    });

    function onMotionChange() {
      if (reducedMotion()) {
        clearRotation();
        showSlide(0);
      }
      if (toggleBtn) toggleBtn.hidden = !(featured.length > 1 && !reducedMotion());
      startRotation();
    }
    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', onMotionChange);
    } else if (typeof motionQuery.addListener === 'function') {
      motionQuery.addListener(onMotionChange);
    }

    paint(reviews);

    return {
      update: function (filtered) {
        paint(filtered);
      }
    };
  }

  function excerpt(text, max) {
    if (!text) return '';
    return text.length > max ? text.slice(0, max - 1) + '…' : text;
  }

  function renderMarquee(root, reviews) {
    if (root.dataset.showTicker !== 'true') return null;
    const marquee = root.querySelector('[data-canicule-reviews-marquee]');
    const trackFwd = root.querySelector('[data-canicule-reviews-marquee-track-fwd]');
    const trackRev = root.querySelector('[data-canicule-reviews-marquee-track-rev]');
    const staticGrid = root.querySelector('[data-canicule-reviews-marquee-static]');
    if (!marquee || !trackFwd || !trackRev || !reviews.length) return null;

    function buildRow(reviews, maxLen) {
      const items = reviews
        .map(function (r) { return r.text; })
        .filter(function (t) { return t && t.length > 10; })
        .map(function (t) { return excerpt(t, maxLen); });
      if (!items.length) return '';
      const doubled = items.concat(items);
      return doubled.map(function (text) {
        return '<span class="canicule-reviews__marquee-item">« ' + escapeHtml(text) + ' »</span>';
      }).join('');
    }

    function paint(filtered) {
      const htmlFwd = buildRow(filtered, 72);
      const htmlRev = buildRow(filtered.slice().reverse(), 64);
      if (!htmlFwd) {
        marquee.hidden = true;
        return;
      }

      if (prefersReducedMotion()) {
        trackFwd.innerHTML = '';
        trackRev.innerHTML = '';
        if (staticGrid) {
          staticGrid.innerHTML = filtered.slice(0, 6).map(function (r) {
            return '<span class="canicule-reviews__marquee-item">« ' + escapeHtml(excerpt(r.text, 90)) + ' »</span>';
          }).join('');
          staticGrid.hidden = false;
        }
        marquee.hidden = false;
        return;
      }

      trackFwd.innerHTML = htmlFwd;
      trackRev.innerHTML = htmlRev;
      if (staticGrid) staticGrid.hidden = true;
      marquee.hidden = false;
    }

    paint(reviews);

    marquee.querySelectorAll('.canicule-reviews__marquee-row').forEach(function (row) {
      row.addEventListener('mouseenter', function () { row.classList.add('is-paused'); });
      row.addEventListener('mouseleave', function () { row.classList.remove('is-paused'); });
      row.addEventListener('focusin', function () { row.classList.add('is-paused'); });
      row.addEventListener('focusout', function () { row.classList.remove('is-paused'); });
    });

    return { update: paint };
  }

  function renderConstellation(root, reviews) {
    const grid = root.querySelector('[data-canicule-reviews-constellation]');
    if (!grid) return null;

    function paint(filtered) {
      delete grid.dataset.caniculeConstellationInit;
      grid.innerHTML = '';
      if (!filtered.length) {
        grid.hidden = true;
        return;
      }

      filtered.forEach(function (review, i) {
        const size = SIZE_PATTERN[i % SIZE_PATTERN.length];
        const article = document.createElement('article');
        article.className = 'canicule-reviews__card canicule-reviews__card--' + size;
        article.setAttribute('role', 'listitem');
        article.dataset.usage = review.usage || 'all';

        article.innerHTML =
          '<div class="canicule-reviews__card-inner">' +
          usageBadge(review) +
          '<blockquote class="canicule-reviews__quote">' + escapeHtml(review.text) + '</blockquote>' +
          '<footer class="canicule-reviews__meta">' +
          attributionHtml(review) +
          (review.date ? '<time datetime="' + escapeHtml(review.date) + '">' + escapeHtml(review.date) + '</time>' : '') +
          productLink(review) +
          '</footer></div>';

        grid.appendChild(article);
      });

      grid.hidden = false;
      initConstellationReveal(grid);
    }

    paint(reviews);
    return { update: paint };
  }

  function initConstellationReveal(container) {
    if (window.CaniculeReviewsConstellation && window.CaniculeReviewsConstellation.init) {
      window.CaniculeReviewsConstellation.init(container);
      return;
    }
    container.querySelectorAll('.canicule-reviews__card').forEach(function (card) {
      card.classList.add('is-landed');
    });
  }

  function renderEmptyState(root, message) {
    const empty = root.querySelector('[data-canicule-reviews-empty]');
    const scene = root.querySelector('.canicule-reviews__scene');
    if (scene) scene.hidden = true;
    [
      '[data-canicule-reviews-summary]',
      '[data-canicule-reviews-attribution]',
      '[data-canicule-reviews-hero]',
      '[data-canicule-reviews-marquee]',
      '[data-canicule-reviews-constellation]',
      '[data-canicule-reviews-intelligence]',
      '[data-canicule-reviews-filters]',
      '[data-canicule-reviews-photos]'
    ].forEach(function (sel) {
      const el = root.querySelector(sel);
      if (el) el.hidden = true;
    });
    if (empty) {
      empty.hidden = false;
      const text = empty.querySelector('[data-canicule-reviews-empty-text]');
      if (text && message) text.textContent = message;
    }
  }

  function initFestival(root, reviews) {
    const hero = renderHeroStage(root, reviews);
    const marquee = renderMarquee(root, reviews);
    const constellation = renderConstellation(root, reviews);

    function onFilter(usage) {
      const filtered = usage === 'all'
        ? reviews.slice()
        : reviews.filter(function (r) { return r.usage === usage; });
      if (hero && hero.update) hero.update(filtered);
      if (marquee && marquee.update) marquee.update(filtered);
      if (constellation && constellation.update) constellation.update(filtered);
    }

    renderFilters(root, reviews, onFilter);
  }

  function renderReviews(root, data, handle) {
    const reviews = collectReviews(data, handle);
    const empty = root.querySelector('[data-canicule-reviews-empty]');
    const attribution = root.querySelector('[data-canicule-reviews-attribution]');
    const scene = root.querySelector('.canicule-reviews__scene');

    if (!reviews.length) {
      renderEmptyState(root);
      return;
    }

    if (empty) empty.hidden = true;
    if (scene) scene.hidden = false;
    if (attribution) attribution.hidden = false;

    renderSummary(root, reviews);
    renderIntelligence(root, data, handle);
    initFestival(root, reviews);
  }

  function initSection(root) {
    if (!root || root.dataset.caniculeReviewsInit === 'true') return;
    root.dataset.caniculeReviewsInit = 'true';

    const handleRaw = root.dataset.productHandle || '';
    const handle = handleRaw === 'all' ? '' : handleRaw;
    const dataUrl = root.dataset.reviewsUrl;
    if (!dataUrl) {
      renderEmptyState(root);
      return;
    }

    fetch(dataUrl)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) {
          renderEmptyState(root);
          return;
        }
        renderReviews(root, data, handle);
      })
      .catch(function () { renderEmptyState(root); });
  }

  function initAll(scope) {
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
